import { gql } from 'graphql-request';

export const getPurposeQuery = gql`
    query purpose($slug: String) {
        purpose: getPurpose(slug: $slug) {
            slug
            name
            description
            treatments {
                slug
                name
                combined
            }
        }
    }
`;

export const getPurposesQuery = gql`
    query purposes($searchTerm: String, $limit: Int, $offset: Int) {
        purposes: getPurposes(searchTerm: $searchTerm, limit: $limit, offset: $offset) {
            count
            rows {
                slug
                name
                treatments {
                    slug
                    name
                    combined
                }
            }
        }
    }
`;
